// extracted by mini-css-extract-plugin
export default {"bar":"ProgressBar_bar__iBZh-"};